import React from 'react';
import classnames from 'classnames';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import BrandedButton from '../../../Buttons/BrandedButton';
import s from './ThumbMiddleContent.scss';
var ThumbMiddleContent = function (_a) {
    var icon = _a.icon, title = _a.title, subtitle = _a.subtitle, buttonTitle = _a.buttonTitle, onButtonClick = _a.onButtonClick, biData = _a.biData, className = _a.className, buttonHref = _a.buttonHref;
    return (React.createElement(ThemeOverride, { theme: ThemeOptions.DARK, tag: "div", className: classnames(s['root'], className) },
        icon && React.createElement("div", { className: s['icon'] }, icon),
        title && React.createElement("div", { className: s['title'] }, title),
        subtitle && React.createElement("div", { className: s['subtitle'] }, subtitle),
        buttonTitle && (React.createElement(BrandedButton, { variant: "brand-green", size: "medium", onClick: onButtonClick, href: buttonHref, biData: biData, className: s['button'] }, buttonTitle))));
};
ThumbMiddleContent.displayName = 'ThumbMiddleContent';
export default ThumbMiddleContent;
//# sourceMappingURL=ThumbMiddleContent.js.map